export default defineNuxtRouteMiddleware(async (to, from) => {
  const domain = await ensureShopDomainResolved()
  if (!domain.shop?.slug) return

  const slug = domain.shop.slug.toLowerCase()

  // Bookmarks like /default/produse on a custom domain → /produse
  if (to.path === `/${slug}` || to.path.startsWith(`/${slug}/`)) {
    const rest = to.path === `/${slug}` ? '/' : to.path.slice(`/${slug}`.length) || '/'
    if (rest !== to.path) {
      // Replace only on first load. During in-app navigation, replace:true
      // overwrites the page we came from (listing) instead of the pending
      // prefixed URL, so Back skips history.
      const isInitial = from.matched.length === 0
      return navigateTo(
        { path: rest, query: to.query, hash: to.hash },
        { replace: isInitial },
      )
    }
  }
})
